import type { McVrmPostBookingStorefrontAssignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const isEligibleForMcVrmPostBookingStorefront = (state: State): boolean => {
	return state.vendor.vendorRaw?.purchaseStatus === 'PAID';
};

export const mcVrmPostBookingStorefrontSelector = (
	state: State,
): McVrmPostBookingStorefrontAssignment => {
	if (!isEligibleForMcVrmPostBookingStorefront(state)) {
		return null;
	}

	const assignment = selectAssignment(state, ['mcVrmPostBookingStorefront']);

	if (assignment === 'control' || assignment === 'variant1') {
		return assignment;
	}

	return null;
};

export const isInMcVrmPostBookingStorefrontExperiment = (state: State) => {
	const assignment = mcVrmPostBookingStorefrontSelector(state);

	return assignment === 'variant1';
};
